/**
 * Projetos do plano Free sem slot na nuvem: metadados no navegador (24h) + layout em gepetto_draft_<id>.
 */

const TTL_MS = 24 * 60 * 60 * 1000;

function storageKey(userId) {
  return `gepetto_free_local_projects_v1_${userId || 'anon'}`;
}

function readRaw(userId) {
  try {
    const raw = localStorage.getItem(storageKey(userId));
    if (!raw) return { v: 1, items: [] };
    const p = JSON.parse(raw);
    if (!p || !Array.isArray(p.items)) return { v: 1, items: [] };
    return { v: 1, items: p.items };
  } catch {
    return { v: 1, items: [] };
  }
}

function writeRaw(userId, data) {
  try {
    localStorage.setItem(storageKey(userId), JSON.stringify({ v: 1, items: data.items || [] }));
  } catch {
    /* quota */
  }
}

export function purgeExpiredFreeLocalProjects(userId) {
  if (!userId) return [];
  const { items } = readRaw(userId);
  const now = Date.now();
  const kept = items.filter((it) => it && it.id && typeof it.expiresAt === 'number' && it.expiresAt > now);
  if (kept.length !== items.length) writeRaw(userId, { items: kept });
  return kept;
}

export function listFreeLocalProjectsForUser(userId) {
  return purgeExpiredFreeLocalProjects(userId);
}

export function isFreeLocalProjectId(userId, projectId) {
  if (!userId || !projectId) return false;
  const items = purgeExpiredFreeLocalProjects(userId);
  return items.some((it) => it.id === projectId);
}

export function registerFreeLocalProject(userId, { id, course_name }) {
  if (!userId || !id) return;
  const items = purgeExpiredFreeLocalProjects(userId);
  if (items.some((it) => it.id === id)) return;
  const now = Date.now();
  items.push({
    id,
    course_name: course_name || '',
    createdAt: now,
    expiresAt: now + TTL_MS,
  });
  writeRaw(userId, { items });
}

export function updateFreeLocalProjectMeta(userId, id, { course_name }) {
  if (!userId || !id) return false;
  const items = purgeExpiredFreeLocalProjects(userId);
  const idx = items.findIndex((it) => it.id === id);
  if (idx === -1) return false;
  if (course_name != null) items[idx].course_name = course_name;
  writeRaw(userId, { items });
  return true;
}

export function removeFreeLocalProject(userId, id) {
  if (!userId || !id) return;
  const items = purgeExpiredFreeLocalProjects(userId).filter((it) => it.id !== id);
  writeRaw(userId, { items });
}
